const UrlRegexWithOptionalProtocol = /^(?:http(s)?:\/\/)?([a-z0-9-_]+\.)*[a-z0-9-_]+\.[a-z]{2,63}(\/[^\s]*\/?)*$/i;

export const validateSchema = {
  name: 'Validate schema',
  type: 'object',
  properties: {
    website: {
      required: true,
      type: 'string',
      pattern: UrlRegexWithOptionalProtocol,
      maxLength: 253,
    },
    business: {
      type: 'string',
      maxLength: 300,
    },
  },
};

export const getWebsiteError = (i18n, setError) => ((errors) => {
  let error = '';
  if (errors && errors.required) {
    error = i18n.getString(_TL_('You have to enter your website to continue.'));
  } else if (errors && errors.maxLength) {
    error = i18n.getString(_TL_('Business website exceeds the maximum allowed length.'));
  } else if (errors && errors.pattern) {
    error = i18n.getString(_TL_('Enter a valid business website.'));
  }
  setError(error);
  if (error) {
    return [error];
  }
  return [];
});

export const getBusinessError = (i18n, setError) => ((errors) => {
  let error = '';
  if (errors && errors.maxLength) {
    error = i18n.getString(_TL_('Your input exceeds the maximum allowed length.'));
  }
  setError(error);
  if (error) {
    return [error];
  }
  return [];
});
